export default __webpack_public_path__ + "static/media/class_x.dce7ffcd.png";